// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "Contacts-module--wrapper--y3ZHJ";
export var item = "Contacts-module--item--NTvuV";
export var red = "Contacts-module--red--1qDEM";
export var yellow = "Contacts-module--yellow--fQr-q";
export var blue = "Contacts-module--blue--DPvd-";
export var icon = "Contacts-module--icon--f3Zsv";